import { render } from "./incidences-by-job-card.vue?vue&type=template&id=2e66ada3"
import script from "./incidences-by-job-card.vue?vue&type=script&lang=js"
export * from "./incidences-by-job-card.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__